import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { Button, Typography } from "@mui/material";
import TenderTable from "./TenderTable";
import axios from "axios";
import VQTable from "./VQTable";
import Tenders from "./FinanceHead/TendersTableFH";
import EMDTable from "./FinanceHead/EMDTable";
import ItemCount from "../../utils/ItemCount";
import PurchaseTable from "./FinanceHead/PurchaseTable";

const FinanceHeadPending = () => {
  const [vq, setVq] = useState();
  const [emd, setEmd] = useState();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [activeTab, setActiveTab] = useState("EMD");
  const [isLoading, setIsLoading] = useState(true);
  const [isVQLoading, setIsVQLoading] = useState(true);
  const [pendingActions, setPendingActions] = useState(false);
  const [vendorCount, setVendorCount] = useState(0);
  const [purchaseCount, setPurchaseCount] = useState(0);

  useEffect(() => {
    const getVendorCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/vendor-emd?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setVendorCount(res.data.length);
      } catch (error) {
        console.log(error);
      }
    };
    getVendorCount();

    const getPurchaseCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/vendor-purchase?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setPurchaseCount(res.data.length);
      } catch (error) {
        console.log(error);
      }
    };
    getPurchaseCount();
  }, []);

  const getVendorTenders = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/tender?username=${storedUser.username}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setVq(res.data);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const getEMD = async () => {
    setEmd();
    setIsLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/vendor-emd?username=${storedUser.username}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setEmd(res.data);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const getPurchase = async () => {
    setEmd();
    setIsLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/vendor-purchase?username=${storedUser.username}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setEmd(res.data);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (activeTab === "EMD") {
      getEMD();
    }
    if (activeTab === "PURCHASE") {
      getPurchase();
    }
  }, [activeTab]);

  useEffect(() => {
    if (localStorage.getItem("pending")) {
      setActiveTab("VQ");
      setPendingActions(true);
      localStorage.removeItem("pending");
    }
  }, []);
  return (
    <Box sx={{ textAlign: "center" }}>
      <Typography variant="h5" textAlign={"start"} fontWeight={"bold"}>
        My Pending Actions
      </Typography>
      <Box className="dashboard-container" sx={{ height: 400, width: "100%" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mb: 2,
            borderBottom: "1px solid #D1D1D1",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: 1,
            }}
          >
            <Button
              className={`dashboard-btns ${
                activeTab === "EMD" ? "active" : ""
              }`}
              onClick={() => {
                setActiveTab("EMD");
                setIsLoading(true);
                // setPendingActions(false);
                // setVq();
                // setIsVQLoading(true);
              }}
            >
              EMD/CMD Received <ItemCount count={vendorCount} />
            </Button>
            <Button
              className={`dashboard-btns ${
                activeTab === "PURCHASE" ? "active" : ""
              }`}
              onClick={() => {
                setActiveTab("PURCHASE");
                setIsLoading(true);
                // setPendingActions(false);
                // setVq();
                // setIsVQLoading(true);
              }}
            >
              Purchase Received <ItemCount count={purchaseCount} />
            </Button>
          </Box>
        </Box>
        {activeTab === "EMD" ? (
          <EMDTable
            vendors={emd}
            activeTab={activeTab}
            isLoading={isLoading}
            getEMD={getEMD}
          />
        ) : (
          <PurchaseTable
            vendors={emd}
            activeTab={activeTab}
            isLoading={isLoading}
            getPurchase={getPurchase}
          />
        )}
      </Box>
    </Box>
  );
};

export default FinanceHeadPending;
